var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuwa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.7,
    cy: 20.7,
    r: 7.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 55.8l-1.5 11-10.8 17.6c-1.2 1.9-.6 4.3 1.3 5.5.7.4 1.4.6 2.1.6 1.3 0 2.7-.7 3.4-1.9l11.3-18.4c.3-.5.5-1 .6-1.6l1-7.4-7.4-5.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43.7l-10.4-3.8c-1.6-2-3.3-4-4.9-6-1.4-1.7-2.7-4.1-5.1-4.5-.9-.1-4.4-.4-5.3-.3-.8.1-1.6.4-2.3.8L35.4 34c-1.4.6-3.1 1.2-4 2.6L25 47.7c-1.1 1.9-.4 4.4 1.5 5.5.6.4 1.3.5 2 .5 1.4 0 2.7-.7 3.5-2l5.7-10 4.3-1.9-3.1 13.9 7.4 5.3 11.1 8v19.2c0 2.2 1.8 4 4 4s4-1.8 4-4V65c0-1.3-.6-2.5-1.6-3.2L51.7 53l2.6-10.8 2.9 3.6c.5.6 1.1 1 1.7 1.2l11.4 4.2c2.1.8 4.4-.3 5.1-2.4.8-2.1-.3-4.4-2.4-5.1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuwa);
export default __webpack_public_path__ + "static/media/GUWA.d4538eec.svg";
export { ForwardRef as ReactComponent };